import actions from './actions';
import mutations from './mutations';
import { ContentBaseTemplateTypeMap } from '~/bundles/content/constants/base_template_types';
import { ContentBaseTemplateLabelMap } from '~/bundles/content/constants/base_template_labels';

function state() {
    return {
        publishTemplateDialogOpen: false,
        unpublishTemplateDialogOpen: false,

        publishTemplateFormData: {
            media_id: null,
            custom_org_id: '',
            standard_org_ids: [],
            type: null
        },

        types: [
            {
                type: ContentBaseTemplateTypeMap.STANDARD,
                label: ContentBaseTemplateLabelMap.STANDARD
            },
            {
                type: ContentBaseTemplateTypeMap.CUSTOM,
                label: ContentBaseTemplateLabelMap.CUSTOM
            }
        ],

        isPublishing: false,
        isLoading: false
    };
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};